<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :tabs="tabs"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :formsConfig="formsConfig"
    :key="pageKey"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Customer"
        :baseView="baseView"
        :createModeIsEditMode="true"
        :primaryLabel="model.CustomerName"
        :secondaryLabel="model.CustomerCode"
        recordType="Customer"
        v-if="model.CustomerCode"
      />
    </template>
    <div class="css-v2 split-view customer-attribute" v-if="loadingCompleted">
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <div class="css-v2 split-view-list">
            <gc-filter-split-view
              :showLeftContainer="showFilterLeftContainer"
              :showRightContainer="showFilterRightContainer"
            >
              <template #leftContent>
                <dx-data-grid
                  :data-source="dataSourceConfig"
                  ref="attributeGrid"
                  :columns="columns"
                  :height="gridHeight - 20"
                  @selection-changed="onSelectionChanged"
                  @content-ready="addGridNoResults($event)"
                  :selection="{ mode: 'single' }"
                  v-if="model.CustomerCode"
                  :columnChooser="{
                    enabled: false,
                  }"
                >
                  <DxSearchPanel :visible="true" />
                  <DxPaging :page-size="50" :enabled="false" />
                  <DxPager :visible="false" />

                  <DxScrolling
                    :mode="'virtual'"
                    :row-rendering-mode="'virtual'"
                    :preloadEnabled="true"
                  />
                  <DxExport :enabled="false" />
                </dx-data-grid>
              </template>
              <template #rightContent>
                <!-- <gc-advance-filter-panel
                  :toolbar="filterToolbar"
                  :setFilterFormHeight="filterFormHeight"
                  :sideBarTabs="sideBarTabs"
                  :filterFormItems="filterFormItems"
                  :filterModel="getAdvanceFilterModel"
                  :isJson="false"
                  :screenType="'supplier-contact-list'"
                  :data-source-config="dataSourceConfig"
                  :initial-filter="initialFilter"
                  v-if="model.CustomerCode"
                >
                </gc-advance-filter-panel> -->
              </template>
            </gc-filter-split-view>
          </div>
        </template>

        <template #rightContent>
          <DxToolbar class="split-view-toolbar">
            <DxItem #default location="before" locate-in-menu="before">
              <div>
                <span class="text-header ml-none"> {{ getFormTitle }}</span>
              </div>
            </DxItem>
            <DxItem
              :options="toolbar.audit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
            />
            <DxItem
              :options="toolbar.edit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review' && getUserPermission"
              :visible="formsConfig.editableOption"
            />

            <DxItem
              :options="toolbar.save"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode != 'review'"
            />

            <DxItem
              :options="toolbar.close"
              location="after"
              widget="dxButton"
            />
          </DxToolbar>
          <div class="view-card responsive-paddings">
            <form v-if="loadingCompleted" @keypress="onKeypress">
              <DxForm
                :form-data.sync="model"
                :read-only="false"
                :show-colon-after-label="false"
                :show-required-mark="false"
                :show-validation-summary="false"
                :validation-group="formsConfig.validationGroup"
                :col-count-by-screen="formsConfig.splitViewColCountByScreen"
                label-location="left"
                :customizeItem="customizeItem"
                :items="items"
                @content-ready="onFormContentReady"
              >
              </DxForm>
            </form>
          </div>
        </template>
      </gc-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import { CustomerService } from "../../_services/api/customers/customer.service";

import BaseViewMixin from "../../v1/_mixins/base.view";
import CustomerTabsMixin from "@/_mixins/customer-tabs.mixin";
import { FeatureStorage } from "../../_services/storage";

import { CustomerAttributesService } from "../../_services/api/customers/customer-attributes.service";
import ArrayStore from "devextreme/data/array_store";

export default {
  mixins: [BaseViewMixin, CustomerTabsMixin],
  async created() {
    this.selectedIndex = this.tabs.findIndex((x) => x.text === "Attributes");
  },
  updated() {},
  components: {},
  data() {
    return {
      toolbar: {
        close: {
          icon: "close",
          tabIndex: -1,
          onClick: this.close,
        },
        edit: {
          icon: "edit",
          tabIndex: -1,
          visible: FeatureStorage.checkPermission("CustomerAttributes", "edit"),
          onClick: () => {
            this.$router.push({
              path: `/customer-attributes/edit/${this.baseView.id}`,
            });
          },
        },
        save: {
          icon: "floppy",
          tabIndex: -1,
          validationGroup: "formsData",
          onClick: (e) => {
            this.$logger.trackEventButtonClickSave();
            this.saveCustomerAttribute(e);
          },
        },
        audit: {
          icon: "clock",
          tabIndex: -1,
          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged
            );
          },
        },
      },
      model: {
        DateChanged: "",
        DateCreated: "",
        ChangedBy: "",
        CreatedBy: "",
        AttributeName: undefined,
      },
      CusAttributes: [],
      localDataSource: new ArrayStore({
        data: [],
      }),
      formItems: [],
      setFormTitle: "",
      AttributeTableDefinitionRecordId: undefined,
    };
  },
  computed: {
    getUserPermission() {
      return FeatureStorage.checkPermission("CustomerAttributes", "edit");
    },
    columns() {
      return [
        {
          caption: "Attribute",
          width: 200,
          dataField: "DisplayName",
        },
        {
          caption: "Value",
          dataField: "DefaultValue",
          alignment: "left",
          format: "##0.00",
        },
      ];
    },
    items() {
      return this.formItems;
    },
    dataSourceConfig() {
      return this.localDataSource;
    },
    showLeftContainer() {
      return !(this.isXSmall && this.baseView.mode !== "");
    },
    showRightContainer() {
      if (
        (this.baseView.mode == "review" || this.baseView.mode == "edit") &&
        this.baseView.id.length < 36
      ) {
        return false;
      }

      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },
    getFormTitle() {
      return this.setFormTitle;
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleLocalRouteChange",
    },
    showRightContainer() {
      setTimeout(() => {
        if (this.$refs["attributeGrid"]) {
          let grid = this.$refs["attributeGrid"].instance;
          grid.updateDimensions();
        }
      }, 10);
    },
  },
  methods: {
    onKeypress(e) {
      if (e.keyCode == 13) {
        e.preventDefault();
      }
    },
    onFormContentReady(e) {
      if (e) {
        if (this.baseView.mode !== "review")
          setTimeout(() => {
            e.component.instance().getEditor("DepositPctRequired").focus();
          }, 100);
      }
    },
    async close() {
      if (this.baseView.mode == "create" || this.baseView.mode == "edit") {
        let confirmLeaving = await this.$confirm(
          "You have unsaved changes. Are you sure you want to leave?",
          "Unsaved changes"
        );

        if (confirmLeaving) {
          let grid = this.$refs["attributeGrid"].instance;
          grid.clearSelection();

          this.baseView.id = this.model.CustomerCode;
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/customer-attributes/${this.baseView.id}`,
          });
        } else {
          this.next(false);
        }
      } else {
        let grid = this.$refs["attributeGrid"].instance;
        grid.clearSelection();

        this.baseView.id = this.model.CustomerCode;
        this.setIgnoreRouteChangeConfirmation();
        this.$router.push({
          path: `/customer-attributes/${this.baseView.id}`,
        });
      }
    },
    backButtonFunction() {
      if (this.isDirty == false) {
        this.setIgnoreRouteChangeConfirmation();
      }
      this.$router.push({
        path: "/customer",
      });
    },
    async handleLocalRouteChange() {
      this.loadingCompleted = false;
      this.localDataSource.clear();
      this.showLoading(true);
      await this.getAttributeTableDefinition();
      let response;
      if (this.baseView.id.length == 36) {
        response = await CustomerService.getByRecordId(
          this.baseView.id,
          "Code,Name,RecordId"
        );
      } else {
        response = await CustomerService.getByCode(
          this.baseView.id,
          "Code,Name,RecordId"
        );
      }

      if (response.data.value.length > 0) {
        this.model.CustomerCode = this.baseView.tempId =
          response.data.value[0].Code;
        this.model.CustomerName = response.data.value[0].Name;
        this.model.CustomerRecordID = response.data.value[0].RecordId;

        await this.getCustomerAttribute(this.model.CustomerRecordID);
      }

      let setFilter = undefined;
      if (this.AttributeTableDefinitionRecordId)
        setFilter = `AttributeTableDefinitionRecordId eq ${this.AttributeTableDefinitionRecordId}`;
      await this.getAttributeColumnDefinition(setFilter);

      this.loadingCompleted = true;

      this.showLoading(false);
    },

    async getAttributeTableDefinition() {
      await CustomerAttributesService.getAttributeTableDefinition().then(
        (res) => {
          if (res.data.value.length > 0) {
            this.AttributeTableDefinitionRecordId = res.data.value[0].RecordId;
          }
        }
      );
    },

    async getCustomerAttribute(recordId) {
      await CustomerAttributesService.getByCustomerRecord(recordId).then(
        (res) => {
          this.CusAttributes = res.data.value;
          if (res.data.value.length > 0) {
            this.model.CreatedBy = res.data.value[0].CreatedBy;
            this.model.DateCreated = res.data.value[0].DateCreated;
            this.model.ChangedBy = res.data.value[0].ChangedBy;
            this.model.DateChanged = res.data.value[0].DateChanged;
          }
        }
      );
    },

    async getAttributeColumnDefinition(setFilter) {
      await CustomerAttributesService.getAttributeColumnDefinition(
        setFilter
      ).then((res) => {
        let data = res.data.value;
        data.forEach((element) => {
          this.CusAttributes.forEach((attributes) => {
            if (attributes[element.AttributeName] !== undefined) {
              this.formItems = [];
              element.DefaultValue = attributes[element.AttributeName];
              element.AttributeRecordId = attributes.RecordId;

              this.setFormTitle = element.DisplayName;
              this.model.AttributeName = element.AttributeName;
              this.formItems.push({
                dataField: element.AttributeName,
                label: {
                  text: element.DisplayName,
                },
                editorType: "dxNumberBox",
                editorOptions: {
                  min: 0,
                  max: 100,
                  onFocusIn: (e) => {
                    e.event.target.select();
                  },
                  format: "##0.00",
                  setp: 0,
                },
              });
            }
          });

          this.localDataSource.insert(element);
        });
      });
    },
    onSelectionChanged({ selectedRowsData }) {
      if (selectedRowsData.length == 0) {
        return;
      }

      this.model[selectedRowsData[0].AttributeName] =
        selectedRowsData[0].DefaultValue;

      this.baseView.id = selectedRowsData[0].RecordId;
      this.$router.push({
        path: `/customer-attributes/review/${selectedRowsData[0].AttributeRecordId}`,
      });
      this.baseView.tempId = this.model.CustomerCode;
    },

    async saveCustomerAttribute() {
      this.showLoading(true);

      let payload = {
        [this.model.AttributeName]: this.model[this.model.AttributeName],
        RecordId: this.model.CustomerRecordID,
      };

      await CustomerAttributesService.save(this.baseView.mode, payload)
        .then(() => {
          this.showLoading(false);
          this.$notify(`Customer Attribute saved successfully`, "success");
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/customer-attributes/review/${this.model.CustomerRecordID}`,
          });
          this.baseView.tempId = this.model.CustomerCode;
        })
        .catch((error) => {
          this.showLoading(false);
          if (error.data.Detail) this.$alert(error.data.Detail, "Server Error");
          else
            this.displayServerError(error, "Customer attributes save failed");
        });
    },
  },
};
</script>

<style lang="scss">
.customer-attribute {
  .attribute-text-area {
    .dx-textbox {
      .dx-invalid-message {
        transform: translate(0px, -15px) !important;
      }
    }
  }
}
</style>
